<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Nagłówek pierwsza kolumna',
              modelPath: [this, 'form', 'header_column_1'],
              required: true
            }),
            new fields.Input({
              label: 'Nagłówek druga kolumna',
              modelPath: [this, 'form', 'header_column_2'],
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text']
            })
          ]
        }
      ]
    }
  }
}
</script>
